import { CommonModule } from '@angular/common';
import { Component, Input, ViewEncapsulation } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

export type ColorChipDato =
  | 'verde'
  | 'rojo'
  | 'naranja'
  | 'gris'
  | 'violeta'
  | 'teal'
  | 'azul';

// Chip compacto de un dato: etiqueta arriba, valor grande y una pista abajo.
//
// Existe porque `app-stat-card` está pensado para un dashboard —valor a 64px y
// 180px de alto mínimo—: dentro de un diálogo amontona todo, y con valores de
// TEXTO («Offline», «B/C») en vez de números el valor se recorta. Acá el valor
// se dimensiona según sea número o texto, y la pista envuelve en varias líneas
// sin desbordar.
//
// Lo comparten la vista de la fila de un dispositivo y el panel general, para
// que las dos se vean igual.
@Component({
  selector: 'app-chip-dato',
  standalone: true,
  imports: [CommonModule, MatIconModule, ],
  template: `
    <div class="chip-dato" [ngClass]="'chip-dato-' + color">
      <div class="cd-label">{{ label }}</div>
      <div class="cd-valor-row">
        @if (icon) {
          <mat-icon class="cd-icon">{{ icon }}</mat-icon>
        }
        <span class="cd-valor" [class.cd-valor-texto]="esTexto">
          {{ valor }}
        </span>
      </div>
      @if (hint) {
        <div class="cd-hint">{{ hint }}</div>
      }
    </div>
  `,
  styleUrl: './chip-dato.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class ChipDatoComponent {
  @Input() public label = '';
  @Input() public valor: string | number = '';
  @Input() public hint?: string;
  @Input() public icon?: string;
  @Input() public color: ColorChipDato = 'gris';

  // Un número va grande; un texto («Offline», «B/C») va más chico, si no se
  // pasa del ancho del chip y hay que recortarlo.
  get esTexto(): boolean {
    return typeof this.valor === 'string' && !/^\d+$/.test(this.valor.trim());
  }
}
